export default __webpack_public_path__ + "static/media/signing-documents.37f86b51.png";